import axios from "axios";
import getHeaders from "../../constants/headers";
import { STORE_BASE_URL } from "../BaseURL";
import getBookingHeader from "../../constants/getBookingHeader";

export const bookOrder = (id, storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order', // for android use
    headers: getBookingHeader(),
    data: JSON.stringify(data),
  });
};


export const getStoreLoad = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-load',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const bookOrderB2BModal = (id, storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/b2b/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/challan', // for android use
    headers: getBookingHeader(),
    data: JSON.stringify(data),
  });
};